export enum IntegrationMode {
    EXPORT = 'EXPORT',
    IMPORT = 'IMPORT',
    SYNC = 'SYNC',
    ADAW = 'ADAW'
}

export enum IntegrationModeFriendly {
    EXPORT = 'Export',
    IMPORT = 'Import',
    SYNC = '2-way Sync',
    SSO = 'SSO',
    'EXPORT, SSO' = 'Export, SSO',
    ADAW = 'Any Data, Anywhere'
}

